/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Search: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M5.11531 5.11531C7.93575 2.29488 12.5087 2.29491 15.3292 5.11531C17.9096 7.69576 18.1267 11.7413 15.9854 14.5714L20.7071 19.293L20.7755 19.3692C21.0958 19.762 21.0732 20.341 20.7071 20.7071C20.341 21.0732 19.762 21.0958 19.3692 20.7755L19.293 20.7071L14.5714 15.9854C11.7413 18.1267 7.69576 17.9096 5.11531 15.3292C2.29491 12.5087 2.29488 7.93575 5.11531 5.11531ZM13.9151 6.52938C11.8757 4.49003 8.56876 4.48999 6.52938 6.52938C4.48999 8.56876 4.49003 11.8757 6.52938 13.9151C8.56878 15.9545 11.8757 15.9545 13.9151 13.9151C15.9545 11.8757 15.9545 8.56878 13.9151 6.52938Z'
      fill='currentColor'
    />
  </React.Fragment>
)
